export default function (Alpine) {
    Alpine.directive('lqip', directive)

    function directive(el, { expression }, {}) {
        const data = Alpine.$data(el);
        const img = new Image();

        img.src = expression;
        img.onload = () => {
            el.style.backgroundImage = 'url('+expression+')';

            if ('imageLoaded' in data) {
                data.imageLoaded = true;
            }
        };
    }
}
